import { CR_SUBMISSION } from '../constants';
import { generateEventMergeId } from '../../../_common/client/tracking';
import { loadReviewSuggestions } from './review-suggestions';
import { ReviewSubmissionClientData_CanSubmit } from '../../types/review-submission-client-data';
import { loadRecommendations } from './load-recommendations';

type ShowSuccessViewParams = {
    rootElement: Pick<HTMLElement, 'querySelector'>;
    clientData: ReviewSubmissionClientData_CanSubmit;
};
export const showSuccessView = async ({ rootElement, clientData }: ShowSuccessViewParams): Promise<void> => {
    const formElement = rootElement.querySelector<HTMLFormElement>(CR_SUBMISSION.PAGE.FORM_SELECTOR);
    const actionsElement = rootElement.querySelector<HTMLElement>(CR_SUBMISSION.PAGE.ACTIONS_SELECTOR);
    const successViewElement = rootElement.querySelector<HTMLElement>(CR_SUBMISSION.PAGE.SUCCESS_VIEW_SELECTOR);

    if (formElement === null) throw new Error('[CR-Submission] showSuccessView: Form not found');
    if (actionsElement === null) throw new Error('[CR-Submission] showSuccessView: Actions not found');
    if (successViewElement === null) throw new Error('[CR-Submission] showSuccessView: Success view not found');

    formElement.classList.add(CR_SUBMISSION.STAR_RATING.ERROR_BANNER_HIDDEN_CLASS);
    actionsElement.classList.add(CR_SUBMISSION.STAR_RATING.ERROR_BANNER_HIDDEN_CLASS);
    successViewElement.classList.remove(CR_SUBMISSION.STAR_RATING.ERROR_BANNER_HIDDEN_CLASS);

    const eventMergeId = generateEventMergeId();

    void Promise.allSettled([
        loadReviewSuggestions({ successViewElement, eventMergeId, clientData }),
        loadRecommendations({ successViewElement, eventMergeId }),
    ]);
};
